import { render, staticRenderFns } from "./clientContactPersonInput.vue?vue&type=template&id=77499ace&"
import script from "./clientContactPersonInput.vue?vue&type=script&lang=js&"
export * from "./clientContactPersonInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports